export enum SearchTab {
  MATCHES = 'matches',
  SKIPPED = 'skipped',
}
